module.exports = __webpack_public_path__ + "img/toyota-Worth.4f5a3060.png";